export function closestParent(child, selectors) {
    while (child) {
        if (child instanceof Element && child.matches(selectors)) {
            return child;
        }
        child = child.parentNode;
    }
    return null;
}
